import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-employer/lni-child-labor-complaint-employer.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-employer/lni-child-labor-complaint-employer.module.js';

export default {
    component,
    module,
};